import config from '../_config/config';
import { authHeader } from '../_helpers';
//console.log( config );
export const projectService = {
    getAll,
    getOne,
    save,
};

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/projects/`, requestOptions)
            .then(handleResponse)
            .then(res => {
                localStorage.setItem('projects', JSON.stringify( res.projects ));
            return res.projects
            })

}

function getOne( projectid ){

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: JSON.stringify({ project: projectid })
                
            };
        
            let params = {
              "project": projectid,
            };
            
            let query = Object.keys(params)
                         .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                         .join('&');
                         
            let url = `${config.apiUrl}/projects/get/` //+ "?" + query
                     
            return fetch( url, requestOptions)
                    .then(handleResponse)
                    .then(res => {
                        //localStorage.setItem('project', JSON.stringify( res.projects ));
                        return res.project
                    })

}


function save( id, data, access ) {
    const requestOptions = {
        method: id ? 'PUT':'POST',
        headers: authHeader(), //{ 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, data, access })
        };


    return fetch(`${config.apiUrl}/projects/save/`, requestOptions)
        .then(handleResponse)
        .then(data => {
          if( data.success ) {
            //console.log( data );
            return data;
          }
        });

}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}